import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ChangeOrderStatus } from '@shared/services/gql.service';
import { Utils } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  selector: 'aux-ag-change-order-status',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div class="flex items-center whitespace-nowrap">
      <div class="mr-1 h-3 w-3 rounded-full" [ngClass]="bgClass"></div>
      <div [ngClass]="textClass">{{ status }}</div>
    </div>
  `,
})
export class ChangeOrderStatusComponent implements ICellRendererAngularComp {
  bgClass!: string;
  params!: ICellRendererParams;
  status!: string;
  textClass!: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const status: ChangeOrderStatus | string = params.data.status || '';

    switch (status) {
      case ChangeOrderStatus.STATUS_APPROVED:
        this.bgClass = 'bg-aux-green-dark';
        this.textClass = 'text-aux-green-dark';
        this.status = 'Approved';
        break;
      case ChangeOrderStatus.STATUS_DECLINED:
        this.bgClass = 'bg-aux-red-dark';
        this.textClass = 'text-aux-red-dark';
        this.status = 'Declined';
        break;
      case ChangeOrderStatus.STATUS_PENDING_APPROVAL:
        this.bgClass = 'bg-aux-blue-light-200';
        this.textClass = 'text-aux-blue-light-200';
        this.status = 'Pending Approval';
        break;
      case ChangeOrderStatus.STATUS_PENDING_REVIEW:
        this.bgClass = 'bg-aux-gray-darkest';
        this.textClass = 'text-aux-gray-darkest';
        this.status = 'Pending Review';
        break;
      default:
        this.bgClass = '';
        this.textClass = '';
        this.status = Utils.zeroHyphen;
        break;
    }
  }

  refresh(): boolean {
    return false;
  }
}
